import type { Token } from "@/domains/core"

import { useChainConfig } from "./use-chain-config"

export const useWrappedToken = () => {
  const chainConfig = useChainConfig()

  return chainConfig.tokens.wrappedNative as Token
}
